export const AC_CREATE_LEAF_NODE = 'AC_CREATE_LEAF_NODE';
export const AC_CREATE_OPERATOR_NODE = 'AC_CREATE_OPERATOR_NODE';
export const AC_CREATE_FUNC_NODE = 'AC_CREATE_FUNC_NODE'; // will probably be spilt into multiple functions
export const AC_CREATE_BRANGE_NODE = 'CREAT_BRANGE_NODE';
export const AC_CREATE_DEFINITION_NODE = 'AC_CREATE_DEFINITION_NODE';

export const AC_MERGE_SELECTED_NODES = 'AC_MERGE_SELECTED_NODES';
export const AC_MERGE_SELECTED_NETANY = 'AC_MERGE_SELECTED_NETANY';
export const AC_SPLIT_SELECTED_NODE = 'AC_SPLIT_SELECTED_NODE';
export const AC_SPLIT_SELECTED_OP_NODE = 'AC_SPLIT_SELECTED_OP_NODE';
export const AC_TOGGLE_SELECTED_NODE = 'AC_TOGGLE_SELECTED_NODE';
export const AC_SELECT_ALL_NODES = 'AC_SELECT_ALL_NODES';
export const AC_SELECT_ALL_NODES_BY_TYPE = 'AC_SELECT_ALL_NODES_BY_TYPE';
export const AC_REMOVE_ALL_NODES = 'AC_REMOVE_ALL_NODES';
export const AC_CLEAR_SELECTION_BOX = 'AC_CLEAR_SELECTION_BOX';
export const AC_REMOVE_NODE_BY_ID = 'AC_REMOVE_NODE_BY_ID';
export const AC_REMOVE_SELECTED_NODES = 'AC_REMOVE_SELECTED_NODES';
export const AC_SELECT_ALL_OPERATORS = 'AC_SELECT_ALL_OPERATORS';
export const AC_CHANGE_SELECTED_OPERATOR = 'AC_CHANGE_SELECTED_OPERATOR';
export const AC_CHANGE_SELECTED_OPERATOR_BY_ID =
  'AC_CHANGE_SELECTED_OPERATOR_BY_ID';
export const AC_DUPLICATE_SELECTED_NODES = 'AC_DUPLICATE_SELECTED_NODES';
export const AC_COPY_SELECTED_NODES = 'AC_COPY_SELECTED_NODES';
export const AC_PASTE_COPIED_NODES = 'AC_PASTE_COPIED_NODES';
export const AC_SET_OVERRIDE_LABEL_BY_ID = 'AC_SET_OVERRIDE_LABEL_BY_ID';
export const AC_SETUP_BULK_JOIN = 'AC_SETUP_BULK_JOIN';
export const AC_CANCEL_BULK_JOIN_SETUP = 'AC_CANCEL_BULK_JOIN_SETUP';
export const AC_MERGE_BULK_JOIN = 'AC_MERGE_BULK_JOIN';
export const AC_REMOVE_FUNCTION_NODE_BY_ID = 'AC_REMOVE_FUNCTION_NODE_BY_ID';
export const AC_CHANGE_FUNC_OF_SELECTED_NODES =
  'AC_CHANGE_FUNC_OF_SELECTED_NODES';
export const AC_SELECT_ALL_FUNCTIONS = 'AC_SELECT_ALL_FUNCTIONS';
export const AC_SELECT_FUNCTION_BY_ID = 'AC_SELECT_FUNCTION_BY_ID';
export const AC_SELECT_ALL_TEMPLATE_OPERATORS_BY_TYPE =
  'AC_SELECT_ALL_TEMPLATE_OPERATORS_BY_TYPE';
export const AC_CHANGE_SELECTED_FUNCTIONS = 'AC_CHANGE_SELECTED_FUNCTIONS';

export const AC_MERGE_OPERATOR_TEXT = 'AC_MERGE_OPERATOR_TEXT'; // iterates tree through and merges text
export const AC_SOME_COPY_PASTE_FUNCS = 'AC_SOME_COPY_PASTE_FUNCS'; // temp

export const AC_SELECTED_LABEL_TYPE = 'AC_SELECTED_LABEL_TYPE';

export const AC_INSERT_NODES = 'AC_INSERT_NODES';

export const AC_OPERATORS_NETANY = 'AC_OPERATORS_NETANY';
export const AC_CREATE_NETANY_LEAF_NODE = 'AC_CREATE_NETANY_LEAF_NODE';
export const AC_REMOVE_NETANY = 'AC_REMOVE_NETANY';

export const SET_DEFINITION_NODES = 'SET_DEFINITION_NODES';
export const SET_BACK_TO_ROOTNODE = 'SET_BACK_TO_ROOTNODE';